import { render, staticRenderFns } from "./KeywordKabayan.vue?vue&type=template&id=5f6358e2"
import script from "./KeywordKabayan.vue?vue&type=script&lang=js"
export * from "./KeywordKabayan.vue?vue&type=script&lang=js"
import style0 from "./KeywordKabayan.vue?vue&type=style&index=0&id=5f6358e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports